'use strict';
import "../common.js";
import "../campaign.js";
import "../../_scss/ballet_pc/ballet_top.scss";

const teachersListSwiper = new Swiper('.js-top-teachers-swiper', {
    slidesPerView: 4,
    spaceBetween: 13,
    navigation: {
        prevEl: '.swiper-teacher_prev',
        nextEl: '.swiper-teacher_next',
    },
});

((w, d) => {})(window, document);